import { Grid } from "@mui/material";
import {
  AmountBox,
  AppAmountBoxWrapper,
  InnerWrapper,
  MainContainer,
  TitleAndActionBox,
} from "../../common";
import { useContext, useEffect, useMemo, useState } from "react";
import { Backdrop, CircularProgress } from "@mui/material";
import { DownloadIconBlack, PlayIcon } from "../../../assets/icons/icon";
import { LanguageContext } from "../../../context/LanguageContext";
import "./styles.module.css";
import StockItemList from "../../container/NewStockBook/StockItemList";
import { UBButton } from "../../../Libraries";
import StockInOutModal from "../../container/NewStockBook/StockInOutModal";
import { useAllStockReport } from "../../../hooks/useAllStockReport";
import BulkUploadModal from "../../container/Stock/BulkUploadModal";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuthContext } from "../../../context/AuthContext";
import { formatNum } from "../../../oscar-pos-core/constants";
import { analytics, triggerLogEvent } from "../../../config/firebase";
import { isDemoMode } from "../../../utils/demoEnviornment";
import NonIdealNew from "../../common/NonIdealNew";
import AppTableFilters from "../../common/AppTableFilters";
import {
  DEFAULT_DATE_FILTERS_EXPORT,
  ITEMS_PER_PAGE,
  STOCK_TABLE_FILTERS,
} from "../../../constants";
import { buildFiltersConfig } from "../../../utils";
import { useFiltersHandler } from "../../../hooks/useFilterHandler";
import useDownlaodPdf from "../../../hooks/useDownlaodPdf";
import moment from "moment";

const EnhanceNewStockbook = () => {
  const location = useLocation();
  const [I18n] = useContext(LanguageContext);
  const { business, user } = useAuthContext();
  const navigate = useNavigate();
  const [showStockInModal, setShowStockInModal] = useState(false);
  const [showBulkUploadModal, setShowBulkUploadModal] = useState(false);
  const [page, setPage] = useState(0);
  const [showDemoModal, setShowDemoModal] = useState(false);

  const {
    filters,
    appliedChips,
    handleFilterChange,
    resetFilters,
    handleRemoveChip,
    isResetFilter,
    setIsResetFilter,
  } = useFiltersHandler(undefined, I18n);

  const {
    isLoading,
    stockList,
    totalStockValue,
    totalStockCount,
    totalLowStockCount,
    totalAllStocks,
    handleStock,
  } = useAllStockReport(business);

  const { onDownload, downloadLoading } = useDownlaodPdf(user);

  useEffect(() => {
    if (location.state?.showDemoModal && isDemoMode()) {
      const timer = setTimeout(() => setShowDemoModal(true), 1500);
      return () => clearTimeout(timer);
    }
  }, [location.state]);

  useEffect(() => {
    const myDiv = document.getElementById("scrollableDiv");
    if (myDiv) myDiv.scrollTop = 0;
    getInitialStock();
  }, [filters]);

  const getInitialStock = () => {
    setPage(0);
    handleStock({
      filter: filters,
      limit: ITEMS_PER_PAGE,
      offset: 0,
    });
  };

  const getMoreStockData = () => {
    setPage((prev) => {
      handleStock({
        filter: filters,
        limit: ITEMS_PER_PAGE,
        offset: (prev + 1) * ITEMS_PER_PAGE,
        isCalculateTotal: false,
      });
      return prev + 1;
    });
  };

  const downloadReport = (startDate, endDate) => {
    let params = {
      template_name: "stockbook.hbs",
      business_id: business.id,
      template_style: "style1",
      template_color: "#414042",
      start_date: startDate ? moment(startDate).format("DD MMM YYYY") : "",
      end_date: endDate
        ? moment(endDate).format("DD MMM YYYY")
        : startDate
          ? moment(startDate).format("DD MMM YYYY")
          : "",
      name: "stockValue.pdf",
      pdf: true,
    };
    onDownload(params);
    triggerLogEvent(analytics, "sb_stock_report_download", { params });
  };

  const handleEditItem = () => {
    navigate(`/Inventory/Create`);
  };

  const handleStockinOut = () => {
    setShowStockInModal(true);
  };

  const handleBulkUpload = () => {
    setShowBulkUploadModal(true);
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event?.key?.toLowerCase() === "n" && event?.shiftKey) {
        event?.preventDefault();
        handleEditItem();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [handleEditItem]);

  const handleWatchVideo = () => {
    triggerLogEvent(analytics, "sb_watch_video");
    // setIsVideoModalOpen(true);
  };

  const stockFigures = useMemo(
    () => [
      {
        title: I18n.total_stock_items,
        id: "total_stock_items",
        amount: formatNum(totalStockCount),
      },
      {
        title: I18n.stock_value,
        id: "stock_value",
        amount: formatNum(totalStockValue),
        rsLabel: true,
      },
      {
        title: I18n.low_stock_items,
        id: "low_stock_items",
        amount: formatNum(totalLowStockCount),
      },
    ],
    [totalStockCount, totalStockValue, totalLowStockCount, I18n],
  );

  const idealState = totalAllStocks <= 0;

  return (
    <MainContainer fluid>
      <Grid container>
        <Grid item md={12}>
          <TitleAndActionBox
            data={{
              id: "stock_book",
              title: "inventory",
            }}
          >
            <UBButton
              id={`stock_book_in/out_btn`}
              title={I18n.stock_in_out}
              onClick={handleStockinOut}
              className={"ubSecondaryButton marginLeft15 stockInOutButton"}
              disabled={idealState}
            />
            <UBButton
              id={`stock_book_upload_btn`}
              title={I18n.bulk_upload}
              onClick={handleBulkUpload}
              className={"ubSecondaryButton marginLeft15"}
            />

            <UBButton
              onClick={handleEditItem}
              id={"stock_book_create_btn"}
              className="ubPrimaryButton fontSize12 fontWeight400 textUppercase marginLeft12"
              title={I18n.create_item}
            />
          </TitleAndActionBox>

          <InnerWrapper className="innerWrapper newInnerWrapper stockBookInnerWrapper">
            {idealState && !isLoading ? (
              <NonIdealNew
                title={I18n.inventory_management}
                subtitle={I18n.create_items_in_easy_steps_and_manage_inventory}
                button1Title="bulk_upload"
                isTransparentButtonOne={true}
                onButton1Click={handleBulkUpload}
                loading={false}
                disabledOne={false}
                buttonOneId="bulk_upload"
                listButton2Title="create_item"
                onListButton2Click={handleEditItem}
                listButtonTwoId="create_items"
                disabledTwo={false}
                buttonTwoId={"watch_video"}
                prefixIconButtonTwo={
                  <PlayIcon width="18px" height="18px" fill="var(--blue500)" />
                }
                // button2Title="watch_video"
                video_footer={{
                  title: I18n.create_item,
                  onClick: handleEditItem,
                }}
                video_url={
                  "https://www.youtube.com/embed/KpMpGauNeDc?si=_xvfwB-A25WKNQO1"
                }
                videoTitle={I18n.inventory_management}
                videoSubtitle={
                  I18n.create_items_in_easy_steps_and_manage_inventory
                }
              />
            ) : (
              <>
                <AppTableFilters
                  filters={STOCK_TABLE_FILTERS}
                  onFilterChange={handleFilterChange}
                  appliedChips={appliedChips}
                  filterState={filters}
                  isResetFilter={isResetFilter}
                  setIsResetFilter={setIsResetFilter}
                  onRemoveChip={(chip) => handleRemoveChip(chip)}
                  filtersConfig={buildFiltersConfig(STOCK_TABLE_FILTERS, [], null, null, I18n.search_by_item_name, [
                      { label: I18n.filter_name_az, value: "Name (A - Z)" },
                      { label: I18n.name_z_a, value: "Name (Z - A)" },
                      {
                        label: I18n.amount_high_to_low,
                        value: "Amount (High to Low)",
                      },
                      {
                        label: I18n.amount_low_to_high,
                        value: "Amount (Low to High)",
                      },
                      {
                        label: I18n.quantity_high_to_low,
                        value: "Quantity (High to Low)",
                      },
                      {
                        label: I18n.quantity_low_to_high,
                        value: "Quantity (Low to High)",
                      },
                    ], null, null, null, I18n)}
                  sendReminderConfig={{
                    onExport: downloadReport,
                    loading: downloadLoading,
                    applyBtnText: I18n.export,
                    spinnerColor: "black",
                    iconComponent: <DownloadIconBlack width="12px" height="12px" />
                  }}
                />

                <AppAmountBoxWrapper>
                  <AmountBox
                    isNonIdeal={!idealState || !(stockList.length > 0)}
                    data={stockFigures}
                  />
                </AppAmountBoxWrapper>

                <StockItemList
                  data={stockList}
                  getMoreStockData={getMoreStockData}
                  getInitialStock={getInitialStock}
                  actions={true}
                  idealState={idealState}
                  totalAllStocks={totalAllStocks}
                  totalStockCount={totalStockCount}
                  isLoading={isLoading}
                  resetFilters={resetFilters}
                />
              </>
            )}
          </InnerWrapper>
        </Grid>

        {showStockInModal && (
          <StockInOutModal
            showStockInModal={showStockInModal}
            setShowStockInModal={setShowStockInModal}
            handleSuccessCallBack={getInitialStock}
          />
        )}
      </Grid>
      <BulkUploadModal
        showModal={showBulkUploadModal}
        setShowModal={setShowBulkUploadModal}
        getInitialStock={getInitialStock}
      />
    </MainContainer>
  );
};

export default EnhanceNewStockbook;
